<template>
	<span>
		<b-nav>
			<b-nav-item
				v-for="(item, index) in links"
				:key="index"
				:to="item.link"
				:title="item.description"
				b-v-tooltip.hover
			>
				<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
				{{ item.name }}
			</b-nav-item>
		</b-nav>
	</span>
</template>
<script>
export default {
	name: "top-home-dynamic-group",
	computed: {
		links() {
			return this.$store.getters["getLinksByGroup"]("Home Group");
		},
		showNav() {
			return this.$store.getters["getLinksByGroup"]("Home Group").length > 0;
		},
	},
};
</script>
